import { useEffect, useState } from 'react';
import { motion } from 'motion/react';
import { MessageCircle } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useLanguage } from '@/contexts/LanguageContext';
import { getSiteContacts, siteContactsDefaults } from '@/lib/supabase/admin-api';

export default function WhatsAppButton() {
  const { t } = useLanguage();
  const [whatsapp, setWhatsapp] = useState(siteContactsDefaults.whatsapp);

  useEffect(() => {
    let active = true;
    getSiteContacts().then((contacts) => {
      if (active) setWhatsapp(contacts.whatsapp);
    });
    return () => {
      active = false;
    };
  }, []);

  const href = whatsapp.message
    ? `https://wa.me/${whatsapp.number}?text=${encodeURIComponent(whatsapp.message)}`
    : `https://wa.me/${whatsapp.number}`;

  return (
    <div className="relative group">
      {/* Pulse effect */}
      <div className="absolute inset-0 rounded-full bg-emerald-500/30 animate-ping opacity-75 -z-10" />

      <motion.a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        title={t("Fale conosco via WhatsApp", "Hable con nosotros por WhatsApp", "Chat with us on WhatsApp")}
        className={cn(
          "w-14 h-14 bg-[#25D366] text-white rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:bg-[#128C7E] border-2 border-white dark:border-zinc-900"
        )}
      >
        <MessageCircle className="h-7 w-7" strokeWidth={2.5} />
      </motion.a>
      
      {/* Optional: label tooltip */}
      <div className="absolute right-16 top-1/2 -translate-y-1/2 bg-popover text-popover-foreground px-3 py-1.5 rounded-md text-[10px] font-black uppercase tracking-wider shadow-md opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none border border-border">
        {t("Falar com especialista", "Hablar con un especialista", "Talk to a specialist")}
      </div>
    </div>
  );
}
